// Fixed banner that sticks to the top of the viewport while an admin is
// impersonating another user. Ensures the admin can't forget they're acting
// as someone else — a walked-away-admin who types a message or changes a
// setting without noticing is the main failure mode this prevents.
//
// Rendered at the App level (above all routes), so it survives nav and
// page transitions. Hidden when `impersonator` is null.
import { useAuth } from "../auth-context";

export function ImpersonationBanner() {
  const { user, impersonator, stopImpersonation } = useAuth();
  if (!impersonator || !user) return null;
  return (
    <div
      className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-yellow-500/95 text-yellow-950 px-4 py-2 text-sm font-medium shadow-md"
      role="alert"
      aria-live="polite"
    >
      <span>
        Acting as <strong>{user.name}</strong> ({user.email}) — impersonated by <strong>{impersonator.name}</strong>
      </span>
      <button
        type="button"
        onClick={() => {
          stopImpersonation().catch(() => {
            // stopImpersonation triggers a hard reload on success, so any
            // error that reaches here is pre-reload. Force-reload anyway to
            // clear whatever state the user is looking at.
            window.location.href = "/coach/admin/users";
          });
        }}
        className="rounded-md bg-yellow-950 px-3 py-1 text-xs font-semibold text-yellow-50 hover:bg-black"
      >
        Return to admin
      </button>
    </div>
  );
}
